<template>
  <v-container v-resize="onResize" style="padding: 0px; max-width: 100%;">
    <DashboardComponent mod="cul" :grid.sync="layout" :updated.sync='layoutUpdate'
    :comps="comps" :size="size" :height="height"/>
  </v-container>
</template>
<script>
import ApexColumn from '@/../../coreui/library/ApexColumn'
import ApexStacked from '@/../../coreui/library/ApexStacked'
import TimelineChart from '@/../../coreui/library/TimelineChart'
import DashboardComponent from '@/../../coreui/library/DashboardComponent'
import axiosInstances from '@/../../coreui/server/axiosInstances'
import TextItem from '@/../../coreui/library/TextGridItem'
import helper from './helper'
import ui from '@/../../coreui/helpers/ui'
import utils from '@/../../coreui/helpers/utils'
import { sync } from 'vuex-pathify'

export default {
    components: {
      DashboardComponent,
      // Gauge,
      // ApexTest,
      // ApexPie
    },
    data: () => ({
      lastheight: 40,
      height: 40,
      windowSize: {
        x: 0,
        y: 0
      },
      harvests: {labels: [], values: []},
      strains: {labels: [], values: []},
      trims: {labels: [], values: []},
      plantings: {labels: [], values: []},

      stateValues: {},
      plantedDates: [],
      growPhase: [],
      strainCount: [],
      labels: [],
      values: [],
      debouncer: true,
      layoutUpdate: false,
      layout: [
        {"x":0,"y":0,"w":2,"h":1,"i":0, static: true, isDraggable: false, isResizable: false},
        {"x":2,"y":0,"w":2,"h":1,"i":1, static: true, isDraggable: false, isResizable: false},
        {"x":4,"y":0,"w":2,"h":1,"i":2, static: true, isDraggable: false, isResizable: false},
        {"x":6,"y":0,"w":2,"h":1,"i":3, static: true, isDraggable: false, isResizable: false},
        {"x":8,"y":0,"w":2,"h":1,"i":4, static: true, isDraggable: false, isResizable: false},
        {"x":10,"y":0,"w":2,"h":1,"i":5, static: true, isDraggable: false, isResizable: false},
        {"x":0,"y":2,"w":4,"h":6,"i":6},
        {"x":4,"y":2,"w":4,"h":6,"i":7},
        {"x":8,"y":2,"w":4,"h":6,"i":8},
        {"x":0,"y":7,"w":6,"h":6,"i":9},
        {"x":6,"y":7,"w":6,"h":6,"i":10}
      ],
      size: 13
    }),
    
    computed: {
      width () {
        this.windowSize.x / 12
      },
      // theme: sync('theme'),
      // themeMenu: sync('themeMenu'),
      mqttTableUpdated: sync('mqtt/mqttTableUpdated'),
      comps() { return  [
        
        {
          args: {
            s: 0,
            label: 'Harvest Weight',
            value: this.harvests.totalWeight ? this.harvests.totalWeight.toFixed(2)+' '+ this.harvests.weightUnit : ''
          },
          component: TextItem,
        },
        {
          args: {
            s: 1,
            label: 'Harvested Plants',
            value: this.harvests.totalCount || 0
          },
          component: TextItem,
        },
        {
          args: {
            s: 2,
            label: 'Live Plants',
            value: this.strains.totalCount || 0
          },
          component: TextItem,
        },
        {
          args: {
            s: 3,
            label: 'Total Flower',
            value: (this.trims.totalFlowerWeight ? this.trims.totalFlowerWeight.toFixed(2) : '0') +' '+ (this.harvests.weightUnit ? this.harvests.weightUnit : '') //' lb',
          },
          component: TextItem
        },
        {
          args: {
            s: 4,
            label: 'Total Smalls',
            value: (this.trims.totalSmallsWeight ? this.trims.totalSmallsWeight.toFixed(2) : '0')  +' '+ (this.harvests.weightUnit ?  this.harvests.weightUnit : '')//|| 0 +' lb'
          },
          component: TextItem,
        },
        {
          args: {
            s: 5,
            label: 'Total Trim',
            value: (this.trims.totalTrimWeight ? this.trims.totalTrimWeight.toFixed(2) : '0') +' '+ (this.harvests.weightUnit ?  this.harvests.weightUnit : '' )//|| 0+' lb'
          },
          component: TextItem,
        },
        {
          args: {
            'name': 'widget 2', 
            'values': [{name: 'Weight', data: this.harvests.values}], 
            'unit': this.harvests.weightUnit ?  this.harvests.weightUnit : '' ,
            'labels': this.harvests.labels,
            'title': 'Harvests', 
            'subtitle':'Wet Weights', 
            'graphSub': 'Weight',
            'fullscreen': true, 
            's': 6,
            'height':this.height, 
            'width':this.width,
            'date': true,
            'palette_light': 'palette1',
            'palette_dark' : 'palette2',
            // 'colorize': false,
            'loading': false
            // 'series': {0: {type: 'line'}}
          },
          component: ApexColumn // ApexPie //ComboChart
        },
        {
          args: {
            'name': 'widget 1', 
            'values': [
              {name: 'Flowering', data: this.strains.fvalues ? this.strains.fvalues : []},
              {name: 'Vegetative', data: this.strains.vvalues ? this.strains.vvalues : []},
              {name: 'Dead', data: this.strains.dvalues ? this.strains.dvalues : []},
              {name: 'Destroyed', data: this.strains.xvalues ? this.strains.xvalues: []}
            ],
            'stacked': true,
            'labels': this.strains.labels,
            'title': 'Plants by Strain', 
            'subtitle':'Active Plants', 
            'fullscreen': true, 
            's': 8,
            'height':this.height, 
            'width':this.width,
            'loading': false,
            'palette_light': 'palette5',
            'palette_dark' : 'palette6',
          },
          component: ApexColumn // ApexPie //PieChart
        },
        {
          args: {
            'name': 'widget 2', 
            'values': [{name: 'Plant Count', data: this.harvests.counts ? this.harvests.counts: []}],
            'labels': this.harvests.countlabels,
            'title': 'Harvests', 
            'subtitle': 'Plant Count', 
            'fullscreen': true, 
            's': 7,
            'height':this.height, 
            'width':this.width,
            // 'colorize': true,
            'annotate': false,
            'loading': false,
            'palette_light': 'palette7',
            'palette_dark' : 'palette8',
          },
          component: ApexColumn 
        },
        {
          args: {
            'stacked': true,
            'name': 'widget 2', 
            'values': [
              {name: 'Flower', data: this.trims.fvalues ? this.trims.fvalues : []},
              {name: 'Smalls', data: this.trims.svalues ? this.trims.svalues : []},
              {name: 'Trim', data: this.trims.tvalues ? this.trims.tvalues : []}
            ],
            'labels': this.trims.labels,
            'title': 'Processed Harvests', 
            'subtitle': 'Dry Weight', 
            'fullscreen': true, 
            's': 9,
            'height':this.height, 
            'width':this.width,
            // 'colorize': true,
            'annotate': false,
            'loading': false,
            'palette_light': 'palette1',
            'palette_dark' : 'palette2',
          },
          component: ApexColumn 
        },
        {
          args: {
            'stacked': true,
            'name': 'widget 2', 
            'values': [
              {name: 'Live', data: this.plantings.live ? this.plantings.live : []},
              {name: 'Dead', data: this.plantings.dead ? this.plantings.dead : []}
            ],
            'labels': this.plantings.labels,
            'title': 'Plantings', 
            'subtitle': 'Live/Dead Count', 
            'fullscreen': true, 
            's': 10,
            'height':this.height, 
            'width':this.width,
            // 'colorize': true,
            'annotate': false,
            'loading': false,
            'palette_light': 'palette1',
            'palette_dark' : 'palette2',
          },
          component: ApexColumn 
        },
      ]
      
      },
    },
    watch: {
      mqttTableUpdated: {
      async handler (val) {
        this.elog('debug', 'mqtt callback for updating table: {}', val)()
        if (val == 'cul_harvest' || val == 'cul_process' || val == 'cul_trim' || val == 'cul_palntings') {
          await this.getData()
        }
        this.mqttTableUpdated = ''
      }
    },
      layout: {
        deep: true,
        handler: function (newVal, oldVal) {
          // console.log('in cultivation: layout updated', newVal)
        }
      },

    },
    methods: {
      onResize () {
        this.windowSize = { x: window.innerWidth, y: window.innerHeight }
        if (this.windowSize.y != this.lastheight) {
          this.height = this.windowSize.y
          this.lastheight = this.height
        }
      },
      getCurTime() {
        // return new Date(2020, 4, 15)
        let d = new Date(Date.now())
        return d
      },
      
      async getData() {
        this.harvests = await helper.getHarvests()
        this.strains = await helper.getStrains()
        this.trims = await helper.getTrims()
        this.plantings = await helper.getPlantings()
        this.elog('trace', 'Dashboard Data - harvests {}, strains {}, trims {}, plantings {}', this.harvests, this.strains, this.trims, this.plantings)()
      }
    },
    
    async mounted () { 
      this.onResize()
      // this.themeMenu = true
      for (let i =0; i < this.comps.length; i++) {
        this.comps[i].args.loading = true
      }
      await this.getData()
      for (let i =6; i < 10; i++) {
        this.comps[i].args.loading = false
      }
      // console.log('?????????', this.myWindow)
      // this.myWindow.App.window.height = this.myWindow.App.window.height -1
      // this.myWindow.App.window.width = this.myWindow.App.window.width -1
    },

    beforeDestroy () {
      // this.themeMenu = false
    }
}
</script>

